"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkItemSolo = exports.Arrow = exports.LastLinkItem = exports.LinkItem = exports.BreadcrumbItemBlock = exports.BreadcrumbBlock = exports.Row = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const reactstrap_1 = require("reactstrap");
const LinkAsButton_1 = __importDefault(require("../../../Components/LinkAsButton"));
const svg_components_1 = require("../../../assets/svg-components");
exports.Row = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  justify-content: center;

  @media print {
    display: none;
  }
`;
exports.BreadcrumbBlock = (0, styled_components_1.default)(reactstrap_1.Breadcrumb) `
  > ol {
    padding: ${props => props.theme.spacing.s10}px 0 0 0;
    margin-bottom: 0;
    margin-top: 0;
    /* Custom style for changing separator  */
    > li + li::before {
      content: '/';
      color: ${props => props.theme.palette.BLUE_GRAY_100};
    }
    ${({ noMargin }) => noMargin && 'margin: 0;'}
  }
`;
exports.BreadcrumbItemBlock = (0, styled_components_1.default)(reactstrap_1.BreadcrumbItem) `
  display: inline;
`;
exports.LinkItem = styled_components_1.default.a `
  display: inline-block;
  /* TODO: Update this!! */
  font-size: ${props => props.theme.typography.size.s2}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  line-height: ${props => props.theme.typography.lineHeight.m1}px;
  margin: 0 ${props => props.theme.spacing.s1}px;
  ${props => props.isFirst && 'margin-left: 0'};
  color: ${props => props.theme.palette.BLUE_100};
  text-decoration: none;

  &:visited {
    text-decoration: none;
    color: ${props => props.theme.palette.BLUE_100};
  }

  &:hover {
    text-decoration: underline;
  }
`;
exports.LastLinkItem = styled_components_1.default.span `
  display: inline-block;
  /* TODO: Update this!! */
  font-size: ${props => props.theme.typography.size.s2}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  line-height: ${props => props.theme.typography.lineHeight.m1}px;
  margin: 0 ${props => props.theme.spacing.s1}px;
  color: ${props => props.theme.palette.BLUE_GRAY_100};
`;
exports.Arrow = (0, styled_components_1.default)(svg_components_1.ArrowRounded) `
  transition: ${props => props.theme.animations.primary};
  margin-right: ${props => props.theme.spacing.s2}px;
`;
exports.LinkItemSolo = (0, styled_components_1.default)(LinkAsButton_1.default) `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: ${props => props.theme.typography.size.s2}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  line-height: ${props => props.theme.typography.lineHeight.m1}px;
  ${props => props.disabled && `color: ${props.theme.palette.BLUE_GRAY_100};}`}

  &:hover ${exports.Arrow} {
    > path {
      stroke: ${props => props.theme.palette.ORANGE_100};
    }
  }
`;
exports.default = {
    Row: exports.Row,
    BreadcrumbBlock: exports.BreadcrumbBlock,
    BreadcrumbItemBlock: exports.BreadcrumbItemBlock,
    LinkItem: exports.LinkItem,
    LastLinkItem: exports.LastLinkItem
};
